var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 65,
    height: 67
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.125 35.4375L72.5625 50.625L64.125 52.3125V62.4375H59.0625L48.9375 60.75L47.25 72.5625H21.9375L18.5625 55.0446C13.365 50.1238 10.125 43.1595 10.125 35.4375C10.125 20.5251 22.2126 8.4375 37.125 8.4375C52.0374 8.4375 64.125 20.5251 64.125 35.4375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 32.0625C28.6875 30.3937 29.1823 28.7624 30.1095 27.3749C31.0366 25.9873 32.3544 24.9059 33.8961 24.2673C35.4379 23.6287 37.1344 23.4616 38.7711 23.7871C40.4078 24.1127 41.9112 24.9163 43.0912 26.0963C44.2712 27.2763 45.0748 28.7797 45.4004 30.4164C45.7259 32.0531 45.5588 33.7496 44.9202 35.2914C44.2816 36.8331 43.2002 38.1509 41.8126 39.078C40.4251 40.0052 38.7938 40.5 37.125 40.5V45.5625M37.125 55.6875V57.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H81V81H0V0Z",
    fill: "#00D0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.d6e6faa83afc423e935bcda9cbf5a20b.svg";
export { ForwardRef as ReactComponent };